import type { Event } from "./events";

export interface Mission extends Omit<Event, 'format'> {
    direction: 'Korea → Egypt' | 'Egypt → Korea';
    applicationDeadline?: string;
}

export const missions: Mission[] = [
    {
        id: 'm1',
        slug: 'korea-egypt-tech-mission',
        title: 'Korea to Egypt Technology Mission',
        date: '2025-08-15',
        location: 'Cairo, Egypt',
        direction: 'Korea → Egypt',
        description: 'Korean technology companies visiting Egypt to explore market opportunities and partnerships.',
        applicationDeadline: '2025-07-15',
        agenda: [
            'Market briefing',
            'Company visits',
            'B2B meetings',
            'Site visits',
        ],
        speakers: [],
    },
    {
        id: 'm2',
        slug: 'egypt-korea-industrial-mission',
        title: 'Egypt to Korea Industrial Mission',
        date: '2025-09-20',
        location: 'Busan, South Korea',
        direction: 'Egypt → Korea',
        description: 'Egyptian industrial companies visiting Busan to explore Korean partnerships and technology transfer.',
        applicationDeadline: '2025-08-20',
        agenda: [
            'Industrial facility tours',
            'Technology demonstrations',
            'Partnership discussions',
        ],
        speakers: [],
    },
    {
        id: 'm3',
        slug: 'korea-egypt-infrastructure-mission',
        title: 'Korea to Egypt Infrastructure Mission',
        date: '2025-10-10',
        location: 'Cairo & Alexandria, Egypt',
        direction: 'Korea → Egypt',
        description: 'Korean infrastructure companies exploring major projects and tenders in Egypt.',
        applicationDeadline: '2025-09-10',
        agenda: [
            'Project presentations',
            'Tender briefings',
            'JV discussions',
        ],
        speakers: [],
    },
    {
        id: 'm4',
        slug: 'egypt-korea-clean-energy-mission',
        title: 'Egypt to Korea Clean Energy Mission',
        date: '2025-11-05',
        location: 'Busan, South Korea',
        direction: 'Egypt → Korea',
        description: 'Egyptian clean energy companies visiting Korea to explore renewable energy technologies and partnerships.',
        applicationDeadline: '2025-10-05',
        agenda: [
            'Clean energy facility visits',
            'Technology workshops',
            'Partnership meetings',
        ],
        speakers: [],
    },
];

